import React from "react";
import { IoMdClose } from "react-icons/io";

const Modal = ({ title, isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className={`backdrop-blur-sm fixed inset-0 flex items-center justify-center z-50`}>
      <div
        className="bg-black opacity-50 absolute inset-0"
        onClick={onClose}
      ></div>
      <div className="relative bg-2 text-p-text h-[90%] max-w-3xl w-[90%] rounded-lg flex flex-col z-10 border border-zinc-700">
        {title && (
          <div className="flex justify-between gap-3 br-1 border-b px-3 py-5">
            <h1 className="px-3 py-1.5 text-xl font-bold text-zinc-200">{title}</h1>
            <div>
              <button
                onClick={onClose}
                className="bg-1 transition-all duration-200 rounded-lg p-1.5 text-zinc-300"
              >
                <IoMdClose />
              </button>
            </div>
          </div>
        )}
        {!title && (
          <button
            onClick={onClose}
            className="absolute top-5 right-5 bg-1 transition-all duration-200 rounded-lg p-1.5 text-zinc-300"
          >
            <IoMdClose />
          </button>
        )}
        <div className="flex-grow overflow-y-auto p-4">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
